export default class EnvironmentVariableIsEmpty extends Error {
  constructor(name: string) {
    super(`Environment variable is empty: ${name}`)

    this.name = 'EnvironmentVariableIsEmpty'
  }
}
